import {
	request
} from '@/js_sdk/request.utils.js';
import {
	configStore
} from '@/stores/config.js';

export function userInfo(data) {
	return request({
		url: '/api/loan/userInfo',
		method: 'POST',
		data
	},true, true)
}


export function lastOrder() {
	return request({
		url: '/api/loan/lastOrder',
		method: 'POST',
		data: {
			page: 1
		}
	})
}

export function myOrderList(data) {
	return request({
		url: '/api/loan/myOrderList',
		method: 'POST',
		data
	})
}

// 获取银行卡信息
export function getBankInfo(data) {
	return request({
		url: '/api/loan/getBankInfo',
		method: 'POST',
		data
	})
}

// 更新银行卡信息
export function setBankInfo(data) {
	return request({
		url: '/api/loan/setBankInfo',
		method: 'POST',
		data
	})
}

// 获取银行卡列表
export function getBankList(data) {
	return request({
		url: '/api/loan/getBankList',
		method: 'POST',
		data
	})
}

// 获取还款已银行卡
export function getRepayBankCard(data) {
	return request({
		url: '/api/loan/getRepayBankCard',
		method: 'POST',
		data
	})
}

// 补录资料
export function supplementData(data) {
	return request({
		url: '/api/loan/supplementData',
		method: 'POST',
		data
	})
}

// 获取还款链接
export function getRepaymentLink(data) {
	return request({
		url: '/api/prod/getRepaymentLink',
		method: 'POST',
		data
	})
}

// 获取订单合同字段
export function getContractInfo(data) {
	const cstore = configStore(); 
	let agreeShow = uni.getStorageSync('agreeShow')
	if(cstore.configData.isCancelInsurance == '1'){
		if(!agreeShow){
			data['isCancelInsurance'] = '0'
			data['isCancelInsuranceRefuse'] = '0'
		}else{
			data['isCancelInsurance'] = '1'
			data['isCancelInsuranceRefuse'] = '1'
		}
	}else{
		data['isCancelInsurance'] = '0'
		data['isCancelInsuranceRefuse'] = '0'
	}
	return request({
		url: '/api/loan/getContractInfo',
		method: 'POST',
		data
	})
}

// 获取打款连接
export function getLoanPayLink(data={}) {
	return request({
		url: '/api/prod/getLoanPayLink',
		method: 'POST',
		data
	})
}

// 设置银行卡账单信息
export function saveBankBillInfo(data={}) {
	return request({
		url: '/api/loan/saveBankBillInfo',
		method: 'POST',
		data
	})
}